import { Box } from "@mui/material";

interface IndicatorProps {
  active: boolean;
}

export const Indicator = ({ active }: IndicatorProps) => {
  return (
    <Box
      mx={2}
      sx={{
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: (theme) => (active ? theme.palette.success.main : theme.palette.error.main),
      }}
    />
  )
};